import React, { useState, useEffect } from "react";
import { Checkbox } from 'react-materialize';

export default function ShowColumnModalItems({data, handleEvents}) {
    return <div key={"showcolumn-modal-items-"+data.inx} className="row">
        {data.columns.map((item, i) => {
            return <div key={"showcolumn-modal-item-"+i} className="col s3 showcolumn-modal-item">
                <Checkbox
                    checked={(data.selectedFields.indexOf(item.name.toString()) >= 0) ? true : false}
                    filledIn
                    id={"showcolumn-modal-item-"+data.inx+"-"+i}
                    name="chk_showcolumn[]"
                    label={item.display_name}
                    value={item.name.toString()}
                    onChange={handleEvents.ChkShowColumn.OnChange}
                />
            </div>
        })}
    </div>
}